import { UserContext } from '~/app';
import { EmployerDashboard } from './EmployerDashboard';
import { ProviderDashboard } from './ProviderDashboard';

export const HlxDashboard = () => {
  const isProvider = UserContext.useSelector((state) =>
    state.matches({ $_AUTHENTICATED: '$_AUTHENTICATED_PROVIDER' })
  );

  if (isProvider) {
    return <ProviderDashboard />;
  }

  return <EmployerDashboard />;
};
